import { useNavigate } from "react-router-dom";
import styled from "styled-components";

function Footer({ showBanner = false }) {
  return (
    <FooterWrapper>
      <Section_0011>
        <Section_0012>
          <Wrapper_0011>
            <Frame38_0001>
              <_2025PaartnerLimitedAllRightsReserved>
                © 2025 Paartner Limited. All Rights Reserved
              </_2025PaartnerLimitedAllRightsReserved>
            </Frame38_0001>
          </Wrapper_0011>
        </Section_0012>
      </Section_0011>
    </FooterWrapper>
  );
}

export default Footer;

const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;


const Section_0011 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    padding: 24px 16px;
  }

  @media (max-width: 767px) {
    padding: 24px 16px;
  }
`;

const Section_0012 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    padding: 0px 16px;
  }

  @media (max-width: 767px) {
    padding: 0px 16px;
  }
`;

const Wrapper_0011 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
